/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Venues_NoneInputs */

const th_event_venues_none = /** @type {(inputs: Event_Venues_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยังไม่ได้กำหนดสนามสำหรับการแข่งขันนี้`)
};

const en_event_venues_none = /** @type {(inputs: Event_Venues_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No venues set for this event yet.`)
};

const ja_event_venues_none = /** @type {(inputs: Event_Venues_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この大会の会場はまだ設定されていません。`)
};

const zh_event_venues_none = /** @type {(inputs: Event_Venues_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尚未为此赛事设置场馆。`)
};

const es_event_venues_none = /** @type {(inputs: Event_Venues_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todavía no hay pabellones asignados a este evento.`)
};

const pt_event_venues_none = /** @type {(inputs: Event_Venues_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum ginásio definido para este evento ainda.`)
};

const id_event_venues_none = /** @type {(inputs: Event_Venues_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada tempat yang ditetapkan untuk acara ini.`)
};

const fr_event_venues_none = /** @type {(inputs: Event_Venues_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune salle définie pour cet événement.`)
};

const tl_event_venues_none = /** @type {(inputs: Event_Venues_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wala pang venue na itinakda para sa event na ito.`)
};

const vi_event_venues_none = /** @type {(inputs: Event_Venues_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa đặt địa điểm nào cho sự kiện này.`)
};

const ko_event_venues_none = /** @type {(inputs: Event_Venues_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 이벤트에 지정된 경기장이 아직 없습니다.`)
};

const de_event_venues_none = /** @type {(inputs: Event_Venues_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für dieses Event sind noch keine Hallen festgelegt.`)
};

const ru_event_venues_none = /** @type {(inputs: Event_Venues_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Для этого события площадки ещё не заданы.`)
};

const tr_event_venues_none = /** @type {(inputs: Event_Venues_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu etkinlik için henüz salon belirlenmedi.`)
};

const it_event_venues_none = /** @type {(inputs: Event_Venues_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun impianto ancora definito per questo evento.`)
};

const pl_event_venues_none = /** @type {(inputs: Event_Venues_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie wskazano jeszcze hal dla tego wydarzenia.`)
};

const uk_event_venues_none = /** @type {(inputs: Event_Venues_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Для цієї події майданчиків ще не визначено.`)
};

const hi_event_venues_none = /** @type {(inputs: Event_Venues_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इस आयोजन के लिए अभी कोई स्थल तय नहीं है।`)
};

const ar_event_venues_none = /** @type {(inputs: Event_Venues_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لم تُحدَّد صالات لهذه الفعالية بعد.`)
};

const ms_event_venues_none = /** @type {(inputs: Event_Venues_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada tempat ditetapkan untuk acara ini.`)
};

const bn_event_venues_none = /** @type {(inputs: Event_Venues_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এই আয়োজনের জন্য এখনও কোনও মাঠ ঠিক হয়নি।`)
};

const zh_tw2_event_venues_none = /** @type {(inputs: Event_Venues_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尚未為本賽事設定場館。`)
};

const zh_hk2_event_venues_none = /** @type {(inputs: Event_Venues_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尚未為本賽事設定場館。`)
};

const ur_event_venues_none = /** @type {(inputs: Event_Venues_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اس ایونٹ کے لیے ابھی کوئی مقام مقرر نہیں۔`)
};

const fa_event_venues_none = /** @type {(inputs: Event_Venues_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هنوز سالنی برای این رویداد تعیین نشده است.`)
};

const sw_event_venues_none = /** @type {(inputs: Event_Venues_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hakuna kumbi zilizopangwa kwa tukio hili bado.`)
};

const nl_event_venues_none = /** @type {(inputs: Event_Venues_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nog geen zalen vastgesteld voor dit evenement.`)
};

/**
* | output |
* | --- |
* | "No venues set for this event yet." |
*
* @param {Event_Venues_NoneInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const event_venues_none = /** @type {((inputs?: Event_Venues_NoneInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Venues_NoneInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_event_venues_none(inputs)
	if (locale === "ja") return ja_event_venues_none(inputs)
	if (locale === "zh") return zh_event_venues_none(inputs)
	if (locale === "es") return es_event_venues_none(inputs)
	if (locale === "pt") return pt_event_venues_none(inputs)
	if (locale === "id") return id_event_venues_none(inputs)
	if (locale === "fr") return fr_event_venues_none(inputs)
	if (locale === "tl") return tl_event_venues_none(inputs)
	if (locale === "vi") return vi_event_venues_none(inputs)
	if (locale === "ko") return ko_event_venues_none(inputs)
	if (locale === "de") return de_event_venues_none(inputs)
	if (locale === "ru") return ru_event_venues_none(inputs)
	if (locale === "tr") return tr_event_venues_none(inputs)
	if (locale === "it") return it_event_venues_none(inputs)
	if (locale === "pl") return pl_event_venues_none(inputs)
	if (locale === "uk") return uk_event_venues_none(inputs)
	if (locale === "hi") return hi_event_venues_none(inputs)
	if (locale === "ar") return ar_event_venues_none(inputs)
	if (locale === "ms") return ms_event_venues_none(inputs)
	if (locale === "bn") return bn_event_venues_none(inputs)
	if (locale === "zh-TW") return zh_tw2_event_venues_none(inputs)
	if (locale === "zh-HK") return zh_hk2_event_venues_none(inputs)
	if (locale === "ur") return ur_event_venues_none(inputs)
	if (locale === "fa") return fa_event_venues_none(inputs)
	if (locale === "sw") return sw_event_venues_none(inputs)
	if (locale === "nl") return nl_event_venues_none(inputs)
	return en_event_venues_none(inputs)
});